var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12px",
    height: "12px",
    fill: "#f8ba3a",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9385_521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FB9046"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.888,
    cy: 8.109,
    r: 5.452,
    fill: "#F8BA3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.974 2.733a5.293 5.293 0 100 10.586 5.293 5.293 0 000-10.586zM2.343 8.026a5.632 5.632 0 1111.263 0 5.632 5.632 0 01-11.263 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.805 2.63V.09c.13-.02.262-.036.395-.05v2.519c-.134.02-.265.043-.395.072z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.768 3.549L2.986 1.766a8.039 8.039 0 00-.303.256l1.772 1.772c.102-.085.206-.167.313-.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.957 4.27L2.19 2.503c-.091.096-.18.194-.265.294L3.699 4.57c.083-.103.169-.203.258-.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.441 4.922l-1.79-1.79a8.03 8.03 0 00-.236.323l1.811 1.811c.068-.117.14-.232.215-.344z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.554 7.223H.037c-.012.13-.022.262-.028.395h2.504c.01-.133.023-.265.041-.395z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.508 8.307H.006c.005.132.013.264.024.395h2.514a5.528 5.528 0 01-.036-.395z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.617 9.133H.08c.018.132.04.264.066.394h2.569a5.458 5.458 0 01-.098-.394z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.525 11.198L1.74 12.982c.083.103.168.205.255.304l1.773-1.773a5.497 5.497 0 01-.243-.315z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24 12.014l-1.768 1.769c.095.091.193.18.292.266l1.775-1.774a5.508 5.508 0 01-.299-.26z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.888 12.535l-1.789 1.789c.105.081.213.16.322.237l1.808-1.809a5.478 5.478 0 01-.341-.217z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.833 13.376v2.54c.13.018.262.034.395.047v-2.517a5.462 5.462 0 01-.395-.07z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.916 13.5V16a7.745 7.745 0 00.395-.006v-2.503a5.543 5.543 0 01-.395.008z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.742 13.45v2.516c.133-.012.265-.028.395-.046v-2.538c-.13.028-.261.05-.395.068z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.759 12.759l1.81 1.81c.109-.077.216-.156.321-.237l-1.789-1.79a5.509 5.509 0 01-.342.217z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.649 12.116l1.77 1.77c.096-.09.191-.181.283-.275l-1.768-1.768a5.531 5.531 0 01-.285.273z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.224 11.523l1.772 1.773c.088-.1.173-.2.256-.304l-1.784-1.784a5.467 5.467 0 01-.244.315z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.293 9.5h2.567a8.01 8.01 0 00.064-.396H13.39c-.027.134-.06.265-.096.395z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.485 8.415h2.504c.007-.13.01-.262.011-.395h-2.5c0 .133-.006.265-.015.395z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.485 7.59h2.505a8.026 8.026 0 00-.03-.395h-2.519c.02.13.034.261.044.394z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.737 5.204l1.807-1.807a8.126 8.126 0 00-.238-.32L12.52 4.864c.077.11.15.224.218.34z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.088 4.32l1.77-1.769a8.056 8.056 0 00-.277-.282l-1.768 1.768c.095.091.187.186.275.284z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.491 3.75l1.774-1.774a8.085 8.085 0 00-.305-.253l-1.786 1.785c.109.077.215.158.317.242z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11 2.612V.076a8.018 8.018 0 00-.396-.045v2.515c.133.017.265.04.395.066z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.025 2.5V0H8c-.124 0-.247.003-.37.008v2.504a5.583 5.583 0 01.395-.012z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.337 2.547V.173c-.133.028-.264.06-.395.094v1.494L5.257.483a7.942 7.942 0 00-.37.145L5.966 2.64l.371-.093z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.823 2.418L4.357.876c.118-.06.238-.119.36-.174l.711 2.355-.329.196-1.757-1.757c.108-.079.22-.154.332-.227l1.149 1.15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.145 3.874c-.07.117-.138.236-.203.356l1.112 1.112L.619 4.91a7.943 7.943 0 00-.144.369l2.217.67.197-.33-1.744-1.744z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.603 6.513H.138a7.98 7.98 0 00-.064.395h2.315l.093-.372-2.06-1.105a7.937 7.937 0 00-.12.384l1.3.698z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.258 10.022c.034.133.072.264.113.394h.87l-.734.394c.047.124.097.247.15.368l1.464-.785-.093-.371H.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.796 11.552l-.622.622c.07.115.144.228.22.339l1.237-1.238-.197-.328-1.655.5c.057.12.118.24.182.357l.835-.252z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.978 14.917c.118.069.238.135.36.198l.536-.536-.21.695c.12.055.243.107.366.157l.45-1.49-.329-.197-1.173 1.173z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.942 15.083v.65c.13.034.262.066.395.094v-1.53l-.372-.094-.705 1.316c.125.045.252.088.38.127l.302-.563z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.657 15.828c.133-.028.265-.06.395-.094v-.703l.327.61c.128-.04.254-.083.379-.13l-.73-1.36-.37.094v1.583z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 14.528l.53.53c.12-.065.239-.132.356-.202l-1.164-1.164-.328.197.451 1.495c.123-.052.244-.106.363-.163l-.209-.693z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.61 12.507c.077-.111.15-.224.22-.34l-.615-.615.826.25a7.84 7.84 0 00.182-.358l-1.647-.497-.196.328 1.23 1.232z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.719 10.365h.926c.04-.13.077-.262.11-.395h-1.823l-.093.371 1.515.813c.052-.121.102-.245.148-.369l-.784-.42z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.895 6.701a7.909 7.909 0 00-.075-.395h-1.308l1.15-.616a7.816 7.816 0 00-.126-.38l-1.903 1.02.093.371h2.17z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.112 5.084l.913-.914a8.035 8.035 0 00-.205-.353L13.277 5.36l.196.328 1.982-.598a8.042 8.042 0 00-.154-.366l-1.19.359z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.574 1.436a8.057 8.057 0 00-.336-.223l-1.05 1.05.424-1.403a8.018 8.018 0 00-.36-.172l-.67 2.214.33.197 1.662-1.663z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.949 1.658V.239a7.951 7.951 0 00-.395-.088v2.293l.372.093L10.979.573a7.954 7.954 0 00-.374-.14L9.95 1.659z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56 8.566s.745-5.511.692-5.556c0-.033.028-.053.028-.08 2.694.2 5.193 2.075 4.934 5.823-.227 3.293-3.291 4.692-5.195 4.692l.261-4.879h-.72z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.343 7.29c.184-1.685 3.336-1.994 4.928-2.102 1.959-.258 5.342-.665 5.846.855-.11 2.663-.957 2.724-2.203 2.797-1.247.072-2.494-.29-3.269-1.223-.726 2.082-3.39 2.058-3.498 2.058-.11 0-1.61-.29-1.804-2.385z",
    fill: "#01C1AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.265 7.87c-.93-.35-1.3-1.28-1.368-1.702 0-.568.645-.645 2.22-.645 1.573 0 2.528.129 2.606.541.077.723-.18 1.807-.542 1.988-.361.18-1.755.258-2.916-.181z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.532 8.355c.746-.491 1.133-1.439.9-2.239-.132-.456-.858-.344-2.219-.129C4 6.18 3.071 6.71 3.174 7.174c.052.761.64 1.565.981 1.703.342.139 1.445.092 2.377-.522z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 3.716l.454 1.224 1.224.454-1.224.453-.453 1.224-.453-1.224-1.225-.454 1.225-.453.453-1.224z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.204 9.33a.141.141 0 00-.152-.129l-4.334.354a.141.141 0 00-.13.152c.097 1.184 1.22 2.037 2.482 1.934 1.262-.103 2.23-1.127 2.134-2.31zm-2.157 2.03c-1.079.088-2.004-.601-2.16-1.536l4.042-.33c-.001.251-.057.493-.16.716h-1.15a.113.113 0 100 .225h1.026c-.326.505-.905.868-1.598.925z",
    fill: "#FE9A54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9385_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9420f9f7008ae9a29ca3592d483c84ed.svg";
export { ForwardRef as ReactComponent };